import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { GridFilterProps } from '../../filters';
import { DateRangeFilterStore, DateRangeFilterWidget, DateRangeValue, Identifiable } from '@custis/common';
import { TTableColumn } from '../../models';
import { FilterWrapper } from '../filter-popup';
import { uniqueId } from 'lodash';
import s from './DateRangeColumnFilter.module.less';

interface Props<TItem extends Identifiable, TFilter, TSorting> extends GridFilterProps<DateRangeValue> {
  column: TTableColumn<TItem, TFilter, TSorting>;
  store: DateRangeFilterStore;
}

export const DateRangeColumnFilter = observer(
  <TItem extends Identifiable, TFilter, TSorting>({
    store,
    value,
    column,
    onReset,
    onConfirm,
    ...rest
  }: Props<TItem, TFilter, TSorting>) => {
    const id = useMemo(() => column.id || uniqueId(), []);

    useEffect(() => {
      store.setRangeValue(value);
    }, []);

    const onClear = () => {
      onReset();
      store.setRangeValue(undefined);
    };

    const onFind = (v: DateRangeValue | undefined) => {
      setTimeout(() => {
        onConfirm(v ?? store.rangeValue);
      }, 100);
    };

    return (
      <FilterWrapper {...rest} onConfirm={onFind} onReset={onClear}>
        <div className={s.FilterWrapper}>
          <DateRangeFilterWidget store={store} id={id} />
        </div>
      </FilterWrapper>
    );
  },
);
